
import {
  Component,
  ComponentRef,
  ElementRef,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  PLATFORM_ID,
  TransferState,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { ErrorHandlingService } from '@barthauer/abc/core/error-handling';
import {
  DxPopupComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { Subject } from 'rxjs';
import { AbcPopupSettings } from './abc-popup-settings';

@Component({
    selector: 'abc-popup',
    template: `
    @if (!component) {
      <div></div>
    } @else {
    }
    <ng-content></ng-content>
    <ng-template #contentComponent></ng-template>
    `,
    styleUrls: ['./abc-popup.component.scss'],
    imports: [],
    providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost]
})
export class AbcPopupComponent extends DxPopupComponent implements OnDestroy {
  @ViewChild('contentComponent', { static: true, read: ViewContainerRef }) contentComponent: ViewContainerRef;
  @Input() component: any;
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    this.wrapperAttr = {
      class: 'abc-popup-default-class',
    };
  }

  override ngOnDestroy(): void {
    this.contentComponent.clear();
  }

  public openPopUp(): ComponentRef<unknown> {
    this.visible = true;
    const componentRef = this.contentComponent.createComponent(this.component);
    return componentRef;
  }

  public applyPopupSettings(popupSettings?: AbcPopupSettings): void {
    if (popupSettings) {
      this.title = popupSettings.title;

      this.height = popupSettings.height;
      this.width = popupSettings.width;

      if (popupSettings.maxHeight) {
        this.maxHeight = popupSettings.maxHeight;
      }

      if (popupSettings.maxWidth) {
        this.maxWidth = popupSettings.maxWidth;
      }

      if (popupSettings.minHeight) {
        this.minHeight = popupSettings.minHeight;
      }

      if (popupSettings.minWidth) {
        this.minWidth = popupSettings.minWidth;
      }

      this.resizeEnabled = popupSettings.resizeEnabled;
      this.shading = popupSettings.shading;
    }
  }

  public async waitForHide(abcError?: ErrorHandlingService, actionAfterHide?: () => Promise<void>): Promise<void> {
    try {
      const subject = new Subject<void>();
      const subscription = this.onHiding.subscribe(() => {
        subject.next();
        subject.complete();
      });
      await subject.asObservable().toPromise();
      if (actionAfterHide) {
        await actionAfterHide();
      }
      subscription.unsubscribe();
    } catch (err) {
      if (abcError) {
        abcError.publish(err);
      } else {
        console.error(err);
      }
    }
  }
}
